// GraphQL queries and mutations for Plans (proxy membership API)

export const listPlansQuery = `
  query ListPlans($input: ListPlansInput) {
    listPlans(input: $input) {
      code
      planList {
        planId
        name
        description
        isActive
        businessType
        createdAt
        updatedAt
      }
    }
  }
`;

export const getPlanQuery = `
  query GetPlan($input: GetPlanInput!) {
    getPlan(input: $input) {
      code
      plan {
        planId
        name
        description
        isActive
        businessType
        createdAt
        updatedAt
      }
    }
  }
`;

export const getPlanPricingQuery = `
  query GetPlanPricing($input: GetPlanPricingInput!) {
    getPlanPricing(input: $input) {
      code
      planPricingList {
        planPricingId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        countryCode
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const createPlanMutation = `
  mutation CreatePlan($input: CreatePlanInput!) {
    createPlan(input: $input) {
      code
      plan {
        planId
        name
        description
        isActive
        businessType
        createdAt
        updatedAt
      }
    }
  }
`;

export const updatePlanMutation = `
  mutation UpdatePlan($planId: String!, $input: UpdatePlanInput!) {
    updatePlan(planId: $planId, input: $input) {
      code
      plan {
        planId
        name
        description
        isActive
        businessType
        createdAt
        updatedAt
      }
    }
  }
`;

export const createPlanPricingMutation = `
  mutation CreatePlanPricing($input: CreatePlanPricingInput!) {
    createPlanPricing(input: $input) {
      code
      planPricing {
        planPricingId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        countryCode
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const updatePlanPricingMutation = `
  mutation UpdatePlanPricing($planId: String!, $planPricingId: String!, $input: UpdatePlanPricingInput!) {
    updatePlanPricing(planId: $planId, planPricingId: $planPricingId, input: $input) {
      code
      planPricing {
        planPricingId
        planId
        planName
        billingCycleId
        billingCycleCode
        priceAmount
        priceCurrency
        countryCode
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;
